import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20banner%20wallpaper%2C%20soft%20warm%20cream%20and%20beige%20gradient%20background%2C%20delicate%20floating%20illustration%20elements%2C%20subtle%20manga%20line%20art%20texture%2C%20elegant%20minimal%20composition%2C%20warm%20atmospheric%20lighting%2C%20gentle%20artistic%20vibe%2C%20no%20text%2C%20abstract%20storytelling%20feel&width=1920&height=1080&seq=hero-banner-main&orientation=landscape"
          alt="韩国漫画网 - 好看的韩漫在线阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20 md:py-0">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-6">
          热门韩漫
          <br />
          在线免费阅读
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          收录全网好看韩国漫画，界面清爽无广告，每日同步更新。
          恋爱、奇幻、动作、悬疑——你想看的韩漫都在这里。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/latest"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-label font-semibold cursor-pointer hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/categories"
            className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-label font-medium cursor-pointer hover:bg-white/25 transition-all duration-300 border border-white/20 whitespace-nowrap"
          >
            浏览分类
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden h-[200px] md:h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20featured%20banner%20strip%2C%20colorful%20comic%20panel%20collage%2C%20various%20characters%20from%20romance%20fantasy%20action%20genres%2C%20warm%20vibrant%20colors%2C%20cinematic%20wide%20format%2C%20dramatic%20composition%2C%20clean%20modern%20Korean%20webtoon%20promotional%20style%2C%20no%20text&width=2400&height=800&seq=hero-banner-strip&orientation=landscape"
              alt="热门韩国漫画推荐"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}